import { render } from "./HeadlineSide.vue?vue&type=template&id=a1c6a926&scoped=true&ts=true"
import script from "./HeadlineSide.vue?vue&type=script&lang=ts"
export * from "./HeadlineSide.vue?vue&type=script&lang=ts"

import "./HeadlineSide.vue?vue&type=style&index=0&id=a1c6a926&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c6a926"]])

export default __exports__